(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSliders(root) {
      root.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
        var range = slider.querySelector('[data-ba-range]');
        if (!range) return;

        function setPosition(val) {
          slider.style.setProperty('--split', val + '%');
        }

        range.addEventListener('input', function () {
          setPosition(this.value);
        });

        /* Touch: translate touch drag into range value */
        var dragging = false;
        slider.addEventListener('touchstart', function (e) {
          dragging = true;
        }, { passive: true });

        slider.addEventListener('touchmove', function (e) {
          if (!dragging) return;
          var rect = slider.getBoundingClientRect();
          var x = e.touches[0].clientX - rect.left;
          var pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
          range.value = pct;
          setPosition(pct);
        }, { passive: true });

        slider.addEventListener('touchend', function () {
          dragging = false;
        }, { passive: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSliders(document); });
    } else {
      initSliders(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvee-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var carousel = document.querySelector('[data-ba-carousel]');
    if (!carousel) return;

    var track   = carousel.querySelector('[data-ba-track]');
    var cards   = Array.from(carousel.querySelectorAll('[data-ba-card]'));
    var dots    = Array.from(carousel.querySelectorAll('[data-ba-dot]'));
    var prevBtn = carousel.querySelector('[data-ba-prev]');
    var nextBtn = carousel.querySelector('[data-ba-next]');
    var ctaBtn  = document.querySelector('[data-ba-cta]');

    var current     = 0;
    var total       = cards.length;
    var dragging    = false;
    var horizDrag   = null;
    var startX      = 0;
    var startY      = 0;
    var delta       = 0;
    var resizeTimer = null;

    function mobile() { return window.innerWidth < 768; }
    function width()  { return carousel.offsetWidth; }
    function base()   { return -(current * width()); }

    /* translateX move (mobile) */
    function move(x, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }

    /* Desktop: snap width for scroll-based navigation */
    function snapWidth() {
      if (!cards[0]) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 20;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function updateDots() {
      dots.forEach(function (d, i) {
        var active = i === current;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
    }

    function goTo(index, animate) {
      current = Math.max(0, Math.min(index, total - 1));
      if (mobile()) {
        move(base(), animate !== false);
      } else {
        var sw = snapWidth();
        if (sw > 0) track.scrollTo({ left: current * sw, behavior: 'smooth' });
      }
      updateDots();
    }

    /* Arrow buttons (desktop) */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Dot clicks */
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    /* ── Touch (mobile translateX) ── */
    carousel.addEventListener('touchstart', function (e) {
      if (!mobile()) return;
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      dragging  = true;
      horizDrag = null;
      delta     = 0;
      track.style.transition = 'none';
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (!dragging || !mobile()) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (horizDrag === null) horizDrag = Math.abs(dx) > Math.abs(dy);
      if (!horizDrag) return;
      e.preventDefault();
      delta = dx;
      move(base() + dx, false);
    }, { passive: false });

    carousel.addEventListener('touchend', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta     = 0;
      horizDrag = null;
    }, { passive: true });

    /* Reset touch state if OS interrupts (notification, call, etc.) */
    carousel.addEventListener('touchcancel', function () {
      dragging  = false;
      delta     = 0;
      horizDrag = null;
      goTo(current);
    }, { passive: true });

    /* ── Mouse drag ── */
    var isDragging   = false;
    var dragStartX   = 0;
    var scrollOrigin = 0;

    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      if (mobile()) {
        delta = 0;
        track.style.transition = 'none';
      } else {
        scrollOrigin = track.scrollLeft;
        track.classList.add('is-dragging');
      }
      e.preventDefault();
    });

    window.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      if (mobile()) {
        if (Math.abs(delta) > width() * 0.25) {
          goTo(delta < 0 ? current + 1 : current - 1);
        } else {
          goTo(current);
        }
        delta = 0;
      } else {
        track.classList.remove('is-dragging');
        var sw = snapWidth();
        if (sw > 0) goTo(Math.round(track.scrollLeft / sw));
      }
    });

    window.addEventListener('mousemove', function (e) {
      /* Auto-reset if mouse button was released outside the window */
      if (!e.buttons) { isDragging = false; return; }
      if (!isDragging) return;
      if (mobile()) {
        delta = e.clientX - dragStartX;
        move(base() + delta, false);
      } else {
        e.preventDefault();
        track.scrollLeft = scrollOrigin - (e.clientX - dragStartX);
      }
    });

    /* Sync dots from native scroll on desktop */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      if (mobile()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var sw = snapWidth();
        if (sw > 0) {
          current = Math.max(0, Math.min(Math.round(track.scrollLeft / sw), total - 1));
          updateDots();
        }
      }, 100);
    }, { passive: true });

    /* Swipe hint */
    function swipeHint() {
      if (!mobile() || total < 2) return;
      setTimeout(function () {
        move(-44, true);
        setTimeout(function () { move(0, true); }, 480);
      }, 700);
    }

    /* Resize */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (mobile()) {
          move(base(), false);
        } else {
          track.style.transform  = '';
          track.style.transition = '';
        }
      }, 150);
    });

    /* CTA → scroll to main ATC and click */
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var mainAtc = document.querySelector('.curvee-product__atc-btn');
        if (mainAtc) {
          mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { mainAtc.click(); }, 500);
        }
      });
    }

    /* Init */
    if (mobile()) {
      move(0, false);
      swipeHint();
    }
    updateDots();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvee-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ── ATC scroll button ── */
    var atcBtn = document.querySelector('[data-bnf-atc]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var atc = document.querySelector('.curvee-product__atc-btn');
        if (atc) {
          atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { atc.click(); }, 500);
        }
      });
    }

    /* ── Mobile carousel ── */
    var carousel = document.querySelector('[data-bnf-carousel]');
    var track    = document.querySelector('[data-bnf-track]');
    if (!carousel || !track) return;

    var cards   = track.querySelectorAll('.curvee-bnf__col');
    var dots    = document.querySelectorAll('[data-bnf-dot]');
    var count   = cards.length;
    var current = 0;
    var dragging    = false;
    var horizDrag   = null;
    var startX      = 0;
    var startY      = 0;
    var delta       = 0;
    var resizeTimer = null;

    function mobile() { return window.innerWidth < 768; }
    function width()  { return carousel.offsetWidth; }
    function base()   { return -(current * width()); }

    function move(x, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }

    function goTo(index, animate) {
      current = Math.max(0, Math.min(index, count - 1));
      move(base(), animate !== false);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    /* Touch */
    carousel.addEventListener('touchstart', function (e) {
      if (!mobile()) return;
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      dragging  = true;
      horizDrag = null;
      delta     = 0;
      track.style.transition = 'none';
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (!dragging || !mobile()) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (horizDrag === null) horizDrag = Math.abs(dx) > Math.abs(dy);
      if (!horizDrag) return;
      e.preventDefault();
      delta = dx;
      move(base() + dx, false);
    }, { passive: false });

    carousel.addEventListener('touchend', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta     = 0;
      horizDrag = null;
    }, { passive: true });

    /* Mouse drag (desktop preview) */
    carousel.addEventListener('mousedown', function (e) {
      if (!mobile()) return;
      startX   = e.clientX;
      dragging = true;
      delta    = 0;
      track.style.transition = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging || !mobile()) return;
      delta = e.clientX - startX;
      move(base() + delta, false);
    });

    document.addEventListener('mouseup', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta = 0;
    });

    /* Dot clicks */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Swipe hint — nudge left then back on first load */
    function swipeHint() {
      if (!mobile() || count < 2) return;
      setTimeout(function () {
        move(-44, true);
        setTimeout(function () { move(0, true); }, 480);
      }, 700);
    }

    /* Resize: re-snap to current slide */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (mobile()) {
          move(base(), false);
        } else {
          track.style.transform  = '';
          track.style.transition = '';
        }
      }, 150);
    });

    /* Init */
    if (mobile()) {
      move(0, false);
      swipeHint();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvee-in-use-media"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var carousel = document.querySelector('[data-imu-carousel]');
    var track    = document.querySelector('[data-imu-track]');
    if (!carousel || !track) return;

    var slides  = track.querySelectorAll('.curvee-in-use__col');
    var dots    = document.querySelectorAll('[data-imu-dot]');
    var count   = slides.length;
    var current = 0;
    var dragging    = false;
    var horizDrag   = null;
    var startX      = 0;
    var startY      = 0;
    var delta       = 0;
    var resizeTimer = null;

    function mobile() { return window.innerWidth < 768; }
    function width()  { return carousel.offsetWidth; }
    function base()   { return -(current * width()); }

    function move(x, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }

    function goTo(index, animate) {
      current = Math.max(0, Math.min(index, count - 1));
      move(base(), animate !== false);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    /* Touch */
    carousel.addEventListener('touchstart', function (e) {
      if (!mobile()) return;
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      dragging  = true;
      horizDrag = null;
      delta     = 0;
      track.style.transition = 'none';
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (!dragging || !mobile()) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (horizDrag === null) horizDrag = Math.abs(dx) > Math.abs(dy);
      if (!horizDrag) return;
      e.preventDefault();
      delta = dx;
      move(base() + dx, false);
    }, { passive: false });

    carousel.addEventListener('touchend', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta     = 0;
      horizDrag = null;
    }, { passive: true });

    /* Mouse drag */
    carousel.addEventListener('mousedown', function (e) {
      if (!mobile()) return;
      startX   = e.clientX;
      dragging = true;
      delta    = 0;
      track.style.transition = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging || !mobile()) return;
      delta = e.clientX - startX;
      move(base() + delta, false);
    });

    document.addEventListener('mouseup', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta = 0;
    });

    /* Dot clicks */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Swipe hint */
    function swipeHint() {
      if (!mobile()) return;
      setTimeout(function () {
        move(-44, true);
        setTimeout(function () { move(0, true); }, 480);
      }, 700);
    }

    /* Resize */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (mobile()) {
          move(base(), false);
        } else {
          track.style.transform  = '';
          track.style.transition = '';
        }
      }, 150);
    });

    /* Init */
    if (mobile()) {
      move(0, false);
      swipeHint();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvee-routine"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var carousel = document.querySelector('[data-rtn-carousel]');
    var track    = document.querySelector('[data-rtn-track]');
    if (!carousel || !track) return;

    var cards   = track.querySelectorAll('.curvee-rtn__col');
    var dots    = document.querySelectorAll('[data-rtn-dot]');
    var count   = cards.length;
    var current = 0;
    var dragging    = false;
    var horizDrag   = null;
    var startX      = 0;
    var startY      = 0;
    var delta       = 0;
    var resizeTimer = null;

    function mobile() { return window.innerWidth < 768; }
    function width()  { return carousel.offsetWidth; }
    function base()   { return -(current * width()); }

    function move(x, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)'
        : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }

    function goTo(index, animate) {
      current = Math.max(0, Math.min(index, count - 1));
      move(base(), animate !== false);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    /* Touch */
    carousel.addEventListener('touchstart', function (e) {
      if (!mobile()) return;
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      dragging  = true;
      horizDrag = null;
      delta     = 0;
      track.style.transition = 'none';
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      if (!dragging || !mobile()) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (horizDrag === null) horizDrag = Math.abs(dx) > Math.abs(dy);
      if (!horizDrag) return;
      e.preventDefault();
      delta = dx;
      move(base() + dx, false);
    }, { passive: false });

    carousel.addEventListener('touchend', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta     = 0;
      horizDrag = null;
    }, { passive: true });

    /* Mouse drag (desktop preview) */
    carousel.addEventListener('mousedown', function (e) {
      if (!mobile()) return;
      startX   = e.clientX;
      dragging = true;
      delta    = 0;
      track.style.transition = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging || !mobile()) return;
      delta = e.clientX - startX;
      move(base() + delta, false);
    });

    document.addEventListener('mouseup', function () {
      if (!dragging || !mobile()) return;
      dragging = false;
      if (Math.abs(delta) > width() * 0.25) {
        goTo(delta < 0 ? current + 1 : current - 1);
      } else {
        goTo(current);
      }
      delta = 0;
    });

    /* Dot clicks */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Swipe hint */
    function swipeHint() {
      if (!mobile() || count < 2) return;
      setTimeout(function () {
        move(-44, true);
        setTimeout(function () { move(0, true); }, 480);
      }, 700);
    }

    /* Resize */
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (mobile()) {
          move(base(), false);
        } else {
          track.style.transform  = '';
          track.style.transition = '';
        }
      }, 150);
    });

    /* Init */
    if (mobile()) {
      move(0, false);
      swipeHint();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curvee-technology"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var stage = document.querySelector('[data-tech-stage]');
    if (!stage) return;

    var slides = Array.from(stage.querySelectorAll('[data-tech-slide]'));
    var dots   = Array.from(document.querySelectorAll('[data-tech-dot]'));
    var n      = slides.length;
    if (n === 0) return;

    var current = 0;

    function applyPositions() {
      var leftIdx  = (current - 1 + n) % n;
      var rightIdx = (current + 1) % n;

      slides.forEach(function (slide, i) {
        slide.classList.remove('is-left', 'is-center', 'is-right', 'is-hidden');
        if (i === current)      slide.classList.add('is-center');
        else if (i === leftIdx) slide.classList.add('is-left');
        else if (i === rightIdx) slide.classList.add('is-right');
        else                    slide.classList.add('is-hidden');
      });

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function rotateNext() {
      current = (current + 1) % n;
      applyPositions();
    }

    function rotatePrev() {
      current = (current - 1 + n) % n;
      applyPositions();
    }

    /* Click side cards */
    stage.addEventListener('click', function (e) {
      var slide = e.target.closest('[data-tech-slide]');
      if (!slide) return;
      if (slide.classList.contains('is-left'))  rotatePrev();
      if (slide.classList.contains('is-right')) rotateNext();
    });

    /* Touch swipe */
    var startX    = 0;
    var startY    = 0;
    var dragging  = false;
    var horizDrag = null;

    stage.addEventListener('touchstart', function (e) {
      startX    = e.touches[0].clientX;
      startY    = e.touches[0].clientY;
      dragging  = true;
      horizDrag = null;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (horizDrag === null) horizDrag = Math.abs(dx) > Math.abs(dy);
      if (!horizDrag) return;
      e.preventDefault();
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 56) {
        dx < 0 ? rotateNext() : rotatePrev();
      }
      horizDrag = null;
    }, { passive: true });

    stage.addEventListener('touchcancel', function () {
      dragging  = false;
      horizDrag = null;
    }, { passive: true });

    /* Mouse drag (desktop) */
    var mouseStartX   = 0;
    var mouseDragging = false;

    stage.addEventListener('mousedown', function (e) {
      mouseStartX   = e.clientX;
      mouseDragging = true;
    });

    document.addEventListener('mouseup', function (e) {
      if (!mouseDragging) return;
      mouseDragging = false;
      if (!e.buttons) {
        var dx = e.clientX - mouseStartX;
        if (Math.abs(dx) > 56) {
          dx < 0 ? rotateNext() : rotatePrev();
        }
      }
    });

    /* Dot clicks */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        current = i;
        applyPositions();
      });
    });

    /* Init */
    applyPositions();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animateHeight(el, fromPx, toPx, duration, onComplete) {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var ease = progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;
        el.style.height = (fromPx + (toPx - fromPx) * ease) + 'px';
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          if (onComplete) onComplete();
        }
      }
      requestAnimationFrame(step);
    }

    document.querySelectorAll('[data-faq-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item    = this.closest('.faq__item');
        var answer  = item.querySelector('.faq__answer');
        var inner   = item.querySelector('.faq__answer-inner');
        var isOpen  = this.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          var from = inner.offsetHeight;
          this.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
          animateHeight(answer, from, 0, 250, function () {
            answer.setAttribute('hidden', '');
            answer.style.height = '';
          });
        } else {
          answer.removeAttribute('hidden');
          answer.style.height = '0px';
          answer.style.visibility = '';
          var to = inner.offsetHeight;
          this.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          animateHeight(answer, 0, to, 280, function () {
            answer.style.height = '';
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {

    function animateHeight(el, fromPx, toPx, duration, onComplete) {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var ease = progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;
        el.style.height = (fromPx + (toPx - fromPx) * ease) + 'px';
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          if (onComplete) onComplete();
        }
      }
      requestAnimationFrame(step);
    }

    document.querySelectorAll('[data-prd-faq-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer  = document.getElementById(this.getAttribute('aria-controls'));
        var isOpen  = this.getAttribute('aria-expanded') === 'true';
        var body    = answer.querySelector('.curvee-prd-faq__answer-body');
        var bodyH   = body.getBoundingClientRect().height;

        if (isOpen) {
          this.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
          animateHeight(answer, bodyH, 0, 280, function () {
            answer.style.height = '0';
            answer.style.overflow = 'hidden';
          });
        } else {
          this.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          answer.style.overflow = 'hidden';
          animateHeight(answer, 0, bodyH, 280, function () {
            answer.style.height = '';
            answer.style.overflow = '';
          });
        }
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-features__tabs').forEach(function (tabList) {
      var section = tabList.closest('.product-features');
      if (!section) return;

      var tabs   = tabList.querySelectorAll('[data-pf-tab]');
      var panels = section.querySelectorAll('.product-features__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = this.getAttribute('data-pf-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-hidden', 'true');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          var target = section.querySelector('#pf-panel-' + targetId);
          if (target) {
            target.classList.add('is-active');
            target.setAttribute('aria-hidden', 'false');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {

    /* ── Gallery ── */
    var featuredImg = document.getElementById('curvee-featured-img');

    function updateGalleryDots(idx) {
      document.querySelectorAll('[data-gallery-dots] [data-dot-index]').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    if (featuredImg) {
      document.querySelectorAll('[data-gallery-thumbs] [data-full-src]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          featuredImg.src    = this.getAttribute('data-full-src');
          featuredImg.srcset = this.getAttribute('data-srcset') || '';
          document.querySelectorAll('[data-gallery-thumbs] button').forEach(function (t) {
            t.classList.remove('is-active');
          });
          this.classList.add('is-active');
          var idx = parseInt(this.getAttribute('data-media-index'), 10);
          if (!isNaN(idx)) updateGalleryDots(idx);
        });
      });
    }

    /* ── Swipe gallery (mobile) ── */
    var galleryFeatured = document.querySelector('[data-gallery-featured]');
    var allThumbs = Array.from(document.querySelectorAll('[data-gallery-thumbs] [data-full-src]'));
    if (galleryFeatured && allThumbs.length > 1) {
      var swipeStartX = 0;
      galleryFeatured.addEventListener('touchstart', function (e) {
        swipeStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      galleryFeatured.addEventListener('touchend', function (e) {
        var diff = swipeStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        var activeThumb = document.querySelector('[data-gallery-thumbs] button.is-active');
        var currentIdx = allThumbs.indexOf(activeThumb);
        var nextIdx = diff > 0
          ? (currentIdx + 1) % allThumbs.length
          : (currentIdx - 1 + allThumbs.length) % allThumbs.length;
        allThumbs[nextIdx].click();
      }, { passive: true });
    }

    /* ── Variant selection ── */
    var pricesEl   = document.getElementById('curvee-variant-prices');
    var form       = document.querySelector('[data-product-form]');
    var productEl  = document.getElementById('curvee-product-json');

    if (pricesEl && form && productEl) {
      var variantPrices = JSON.parse(pricesEl.textContent);
      var productData   = JSON.parse(productEl.textContent);

      function getSelectedOptions() {
        var opts = [];
        form.querySelectorAll('[data-option-position]:checked').forEach(function (input) {
          opts[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
        });
        return opts;
      }

      function findVariant(options) {
        return productData.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === options[i]; });
        });
      }

      function updateProduct(variant) {
        if (!variant) return;
        var priceData = variantPrices.find(function (p) { return p.id === variant.id; });
        if (!priceData) return;

        /* Price */
        var priceEl   = document.querySelector('[data-current-price]');
        var compareEl = document.querySelector('[data-compare-price]');
        var savingsEl = document.querySelector('[data-savings-badge]');
        var stickyPrice = document.querySelector('[data-sticky-price]');

        if (priceEl)    priceEl.textContent = priceData.price;
        if (stickyPrice) stickyPrice.textContent = priceData.price;

        if (compareEl) {
          if (priceData.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = priceData.compare_at_price;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (savingsEl) {
          if (variant.compare_at_price > variant.price) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            savingsEl.textContent = 'Save ' + pct + '%';
            savingsEl.hidden = false;
          } else {
            savingsEl.hidden = true;
          }
        }

        /* Variant ID */
        var idInput = form.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;

        /* ATC state */
        var atcBtn    = form.querySelector('[data-main-atc]');
        var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
        var isAvail   = priceData.available;

        if (atcBtn) {
          atcBtn.disabled     = !isAvail;
          atcBtn.textContent  = isAvail
            ? (atcBtn.getAttribute('data-atc-text') || 'Add to Cart')
            : (atcBtn.getAttribute('data-sold-text') || 'Sold Out');
        }
        if (stickyBtn) stickyBtn.disabled = !isAvail;

        /* Gallery: swap to variant featured media if available */
        if (variant.featured_media && featuredImg) {
          var media = productData.media
            ? productData.media.find(function (m) { return m.id === variant.featured_media.id; })
            : null;
          if (media) {
            var newSrc = media.src || '';
            if (newSrc) featuredImg.src = newSrc;
          }
        }
      }

      form.addEventListener('change', function (e) {
        if (!e.target.hasAttribute('data-option-position')) return;
        var variant = findVariant(getSelectedOptions());
        if (variant) updateProduct(variant);
      });
    }

    /* ── Sticky ATC ── */
    var mainAtc   = document.querySelector('[data-main-atc]');
    var stickyBar = document.querySelector('[data-sticky-bar]');

    if (mainAtc && stickyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(mainAtc);

      var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () { mainAtc.click(); });
      }
    }

    /* ── Quantity buttons ── */
    var qtyInput = document.querySelector('[data-qty-input]');
    if (qtyInput) {
      document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(this.getAttribute('data-qty-change'), 10);
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        });
      });
    }

    /* ── Bundle Selector ── */
    var bundleCards   = document.querySelectorAll('[data-bundle-card]');
    var bundleQtyEl   = document.querySelector('[name="quantity"]');
    var bundlePriceEl = document.querySelector('[data-current-price]');
    var bundleCompEl  = document.querySelector('[data-compare-price]');
    var bundleStickyP = document.querySelector('[data-sticky-price]');

    function selectBundle(card) {/* Update selected styling */
    bundleCards.forEach(function(c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
    });

    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');

    /* Read variant ID from the bundle card */
    var variantId = Number(card.dataset.variantId);
    console.log("Bundle clicked:", variantId);

    /* Find the Shopify variant */
    var variant = productData.variants.find(function(v) {
        return Number(v.id) === variantId;
    });

    if (!variant) {
        console.log('Variant not found:', variantId);
        return;
    }

    /* Update hidden Shopify variant ID */
    var idInput = form.querySelector('[data-variant-id]');
    if (idInput) {
        idInput.value = variant.id;
    }

    /* Update product price from Shopify variant */
    updateProduct(variant);

    /* Override compare price + savings badge using bundle card's own displayed prices */
    var origText = card.dataset.bundleOrig  || '';
    var saleText = card.dataset.bundlePrice || '';
    var bundleCompareEl = document.querySelector('[data-compare-price]');
    var bundleSavingsEl = document.querySelector('[data-savings-badge]');

    function parseRand(str) {
      if (!str) return 0;
      return parseFloat(str.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
    }

    var origAmt = parseRand(origText);
    var saleAmt = parseRand(saleText);

    if (bundleCompareEl) {
      if (origText && origAmt > saleAmt) {
        bundleCompareEl.textContent = origText;
        bundleCompareEl.hidden = false;
      } else {
        bundleCompareEl.hidden = true;
      }
    }
    if (bundleSavingsEl) {
      if (origAmt > saleAmt && origAmt > 0) {
        var savePct = Math.round((origAmt - saleAmt) / origAmt * 100);
        bundleSavingsEl.textContent = 'Save ' + savePct + '%';
        bundleSavingsEl.hidden = false;
      } else {
        bundleSavingsEl.hidden = true;
      }
    }

    /* Always purchase one package */
    if (bundleQtyEl) {
        bundleQtyEl.value = 1;
    }
}

    if (bundleCards.length) {
      bundleCards.forEach(function (card) {
        card.addEventListener('click', function () { selectBundle(this); });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectBundle(this); }
        });
      });

      /* Initialise price from the default-selected bundle on load */
      var defaultBundle = document.querySelector('[data-bundle-card].is-selected');
      if (defaultBundle) selectBundle(defaultBundle);
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
